'use client';

import { c as _c } from "react/compiler-runtime";
import { Dispatch, Ref, SetStateAction, useImperativeHandle } from 'react';
import useSWR from 'swr';
import { usePublicProfileContext } from '@/context/PublicProfileContext';
import { getPublicFollowCounts } from '@/services/community';
import { useTranslations } from 'next-intl';
type GuestFollowCountsProps = {
  ref?: Ref<GuestFollowCountsRef>;
  setIsButtonEnabled: Dispatch<SetStateAction<boolean>>;
};
export type GuestFollowCountsRef = {
  mutateFollowCounts: () => void;
};
export default function GuestFollowCounts(t0) {
  const $ = _c(25);
  const {
    ref,
    setIsButtonEnabled
  } = t0;
  const t = useTranslations();
  const {
    preferredUsername
  } = usePublicProfileContext();
  let t1;
  if ($[0] !== preferredUsername) {
    t1 = () => getPublicFollowCounts({
      preferredUsername
    });
    $[0] = preferredUsername;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setIsButtonEnabled) {
    t2 = {
      onSuccess: () => {
        setIsButtonEnabled(true);
      }
    };
    $[2] = setIsButtonEnabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: t3,
    mutate: mutateFollowCounts
  } = useSWR(preferredUsername ? `getGuestFollowCounts:${preferredUsername}` : null, t1, t2);
  let t4;
  if ($[4] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    followingsCount: t5,
    followersCount: t6
  } = t4;
  const followingsCount = t5 === undefined ? 0 : t5;
  const followersCount = t6 === undefined ? 0 : t6;
  let t7;
  if ($[6] !== mutateFollowCounts) {
    t7 = () => ({
      mutateFollowCounts
    });
    $[6] = mutateFollowCounts;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  useImperativeHandle(ref, t7);
  let t8;
  if ($[8] !== followersCount) {
    t8 = <span className="subheader-3 md:subheader-2 text-white">{followersCount}</span>;
    $[8] = followersCount;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t) {
    t9 = t("profile-page.intro-followers");
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8 || $[13] !== t9) {
    t10 = <p className="body-1 flex items-center gap-1 max-md:text-[14px]">{t8}{t9}</p>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== followingsCount) {
    t11 = <span className="subheader-3 md:subheader-2 text-white">{followingsCount}</span>;
    $[15] = followingsCount;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t("profile-page.intro-following");
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <p className="body-1 flex items-center gap-1 max-md:text-[14px]">{t11}{t12}</p>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t13) {
    t14 = <>{t10}{t13}</>;
    $[22] = t10;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}